import { Link as RouterLink, useHistory } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import AuthShell from "../auth/AuthShell";

const NotFound = () => {
  const history = useHistory();

  return (
    <AuthShell
      slim
      title="404"
      subtitle="The page you requested was not found."
    >
      <Stack spacing={3} alignItems="center" sx={{ mt: 1 }}>
        <Box
          aria-hidden
          sx={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            background:
              "linear-gradient(135deg, var(--ba-amber-tint) 0%, var(--ba-amber) 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "var(--ba-shadow-amber)",
          }}
        >
          <Typography sx={{ fontSize: 48, fontWeight: 800, color: "secondary.dark" }}>
            ?
          </Typography>
        </Box>

        <Typography variant="body1" align="center" sx={{ color: "text.secondary" }}>
          You may have mistyped the address, or the page may have moved.
        </Typography>

        <Button
          component={RouterLink}
          to="/apps"
          variant="contained"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={() => history.push("/apps")}
        >
          Go back home
        </Button>
      </Stack>
    </AuthShell>
  );
};

export default NotFound;
